<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <el-backtop :bottom="100" :visibility-height="50"></el-backtop>
  </div>
</template>

<script>
import Header from "./views/header.vue"
import Footer from "./views/footer.vue"
export default {
  data(){
    return{

    }
  },
  components:{
    Header,
    Footer
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
</style>
